import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Track-record numbers are served only to authenticated admins so they never
// appear in the shipped JS bundle. Pages using this are wrapped in AdminGate,
// so the session cookie is guaranteed to be present when the fetch fires.
export function useTrackRecordStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/admin/track-record`, { withCredentials: true })
      .then((r) => {
        if (!cancelled) setStats(r.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return stats;
}

export function useEquityCurve(stats) {
  return useMemo(() => {
    if (!stats) return [];
    const { start: START, end: END, total_trades: n, drawdowns: DRAWDOWNS } = stats;
    const phase1End = Math.floor(n * 0.91); // reaches the peak
    const pts = [];
    for (let t = 0; t <= n; t++) {
      let eq;
      if (t <= phase1End) {
        eq = START * Math.pow(END / START, t / phase1End);
      } else {
        const p = (t - phase1End) / (n - phase1End);
        const wiggle = Math.sin(p * Math.PI * 3) * 0.015 + Math.sin(p * Math.PI * 7) * 0.006;
        eq = END * (1 + wiggle);
      }
      for (const [dt, drop, recover] of DRAWDOWNS) {
        if (t >= dt && t < dt + recover) {
          const p = (t - dt) / recover;
          const factor = p < 0.5 ? 1 - drop * (p * 2) : 1 - drop * (2 - p * 2);
          eq *= factor;
        }
      }
      pts.push({ t, equity: Math.round(eq) });
    }
    pts[pts.length - 1].equity = END;
    return pts.filter((_, i) => i % 2 === 0 || i === pts.length - 1);
  }, [stats]);
}

export const fmt = (n) => {
  if (n >= 1000) return `$${(n / 1000).toFixed(n >= 100000 ? 0 : 1)}k`;
  return `$${n}`;
};
